export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const FETCH_USER_ATTRIBUTES_REQUEST = 'FETCH_USER_ATTRIBUTES_REQUEST';
export const FETCH_USER_ATTRIBUTES = 'FETCH_USER_ATTRIBUTES';
export const SET_USER_ATTRIBUTE = 'SET_USER_ATTRIBUTE';
export const REMOVE_USER_ATTRIBUTE = 'REMOVE_USER_ATTRIBUTE';